// Runs `fn` over `items` with at most `limit` calls in flight at once,
// instead of firing them all in parallel (which can exhaust the backend's
// DB connection pool for large inputs). Results are returned in input order.
export const mapWithConcurrencyLimit = async <T, R>(
  items: T[],
  limit: number,
  fn: (item: T, index: number) => Promise<R>,
): Promise<R[]> => {
  const results: R[] = new Array(items.length)
  let nextIndex = 0

  const worker = async (): Promise<void> => {
    while (nextIndex < items.length) {
      const currentIndex = nextIndex
      nextIndex += 1
      results[currentIndex] = await fn(items[currentIndex], currentIndex)
    }
  }

  await Promise.all(
    new Array(Math.min(limit, items.length)).fill(null).map(() => worker()),
  )

  return results
}
